import { useState, useEffect } from "react";
import Header from "../../../componente/header";
import "./style.css";
import api from "../../../services/api";
import Modal from "react-modal";
import PopUp from "../../../componente/popup";
import PopUp2 from "../../../componente/popup";
import PopUpMotivoExclusao from "../../../componente/popup";
import PopUpMotivoExclusao2 from "../../../componente/popup";
import { podeInserir, podeEditar, podeExcluir } from "../../../componente/permissoes";

function CadEquipe() {
  const [listafuncionario, setlistafuncionario] = useState([]);
  const [lista, setlista] = useState([]);
  const [listafunc, setlistafunc] = useState([]);
  const [listaequipefuncionario, setlistaequipefuncionario] = useState([]);

  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);

  const [edtcodequipe, setedtcodequipe] = useState(0);
  const [edtdescricao, setedtdescricao] = useState("");
  const [edtcodfuncionario, setedtcodfuncionario] = useState(0);
  const [edtativo, setedtativo] = useState("");

  const [codequipefuncionario, setcodequipefuncionario] = useState(0);
  const [codfuncionario, setcodfuncionario] = useState(0);

  const [qtdeItensLanc, setqtdeItensLanc] = useState(0);

  const [novo, setnovo] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenMotivoExclusao, setIsOpenMotivoExclusao] = useState(false);
  const [isOpenFunc, setIsOpenFunc] = useState(false);
  const [isOpenFuncMotivoExclusao, setIsOpenFuncMotivoExclusao] = useState(false);
  const [edtMotivo, setEdtMotivo] = useState("");

  const handleOpen = (cad) => {
    setedtcodequipe(cad.codequipe);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    setEdtMotivo("");
    setIsOpenMotivoExclusao(true);
  };

  const handleInformarMotivoExclusao = () => {
    if (edtMotivo !== "") {
      Excluir();
      setIsOpenMotivoExclusao(false);
      ListarEquipe();
    } else {
      alert("Descreva o motivo antes de informar");
    }
  };

  const handleCloseMotivoExclusao = () => {
    setIsOpenMotivoExclusao(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOpenFunc = (cad) => {
    setcodequipefuncionario(cad.codequipefuncionario);
    setIsOpenFunc(true);
  };

  const handleConfirmaFunc = () => {
    setIsOpenFunc(false);
    setEdtMotivo("");
    setIsOpenFuncMotivoExclusao(true);
  };

  const handleInformarMotivoExclusaoFunc = () => {
    if (edtMotivo !== "") {
      ExcluirCadItem();
      setIsOpenFuncMotivoExclusao(false);
      ListarEquipeFuncionario();
    } else {
      alert("Descreva o motivo antes de informar");
    }
  };

  const handleCloseMotivoExclusaoFunc = () => {
    setIsOpenFuncMotivoExclusao(false);
  };

  const handleCloseFunc = () => {
    setIsOpenFunc(false);
  };

  function ListarEquipeFuncionario() {
    api
      .get("/v1/cadastro/equipefuncionario", {
        params: {
          codequipe: edtcodequipe,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlistaequipefuncionario(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarEquipeFuncionario();
  }, [showform, qtdeItensLanc]);

  function ListarFuncionario() {
    api
      .get("v1/cadastro/funcionario", {
        params: {
          busca: '',
          usapaginacao:"N",
          offset: 0,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlistafuncionario(response.data);
        setlistafunc(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarFuncionario();
  }, [showform]);

  function ListarEquipe() {
    api
      .get("v1/cadastro/equipe", {
        params: {
          busca: abusca,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarEquipe();
  }, [abusca, showform]);

  function Cadastrar() {
    api
      .post(
        "v1/cadastro/equipe",
        {
          descricao: edtdescricao,
          codfuncionario: edtcodfuncionario,
          ativo: edtativo,
          codusuario: localStorage.getItem("tempCodUsuario"),
          excluido: "N",
          codempresa: 1,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        setabusca("a");
        setabusca("");
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/equipe",
        {
          codequipe: edtcodequipe,
          codfuncionario: edtcodfuncionario,
          descricao: edtdescricao,
          codusuario: localStorage.getItem("tempCodUsuario"),
          ativo: edtativo,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        ListarEquipe();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/equipe", {
        params: {
          codequipe: edtcodequipe,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        ListarEquipe();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
    setshowform(false);
  }

  function closeModal() {
    setshowform(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodequipe(0);
    setedtcodfuncionario(0);
    setedtdescricao("");
    setedtativo("S");

    setcodfuncionario(0);
  }

  function openModalEditar(props) {
    setshowform(true);
    setnovo(false);

    setedtcodequipe(props.codequipe);
    setedtcodfuncionario(props.codfuncionario);

    setedtdescricao(props.descricao);
    setedtativo(props.ativo);

    setcodfuncionario(0);
  }

  function AddFuncionario() {   
    if (edtcodequipe === 0) {
      if (edtcodfuncionario === 0) {
        alert("Informe o funcionário");
      } else {
        CadastrarNovo();
      }
    } else if (codfuncionario === 0) {
      alert("Informe o funcionário");
    } else {
      CadastrarEquipeFunc();
    }
  }

  function CadastrarNovo() {
    api
      .post(
        "v1/cadastro/equipe",
        {
          descricao: edtdescricao,
          codfuncionario: edtcodfuncionario,
          ativo: edtativo,
          codusuario: localStorage.getItem("tempCodUsuario"),
          excluido: "N",
          codempresa: 1,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then((response) => {
        setedtcodequipe(response.data.codequipe);

        api
          .post(
            "v1/cadastro/equipefuncionario",
            {
              codequipe: edtcodequipe,
              codfuncionario,
              codempresa: 1,
              codusuario: localStorage.getItem("tempCodUsuario"),
              ativo: "S",
              excluido: "N",
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
              },
            }
          )
          .then(() => {
            setcodfuncionario(0);

            setqtdeItensLanc(listaequipefuncionario.length + 1);
          })
          .catch(function (err) {
            console.log("ops! ocorreu um erro: " + err);
          });
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function CadastrarEquipeFunc() {
    api
      .post(
        "v1/cadastro/equipefuncionario",
        {
          codequipe: edtcodequipe,
          codfuncionario,
          codempresa: 1,
          codusuario: localStorage.getItem("tempCodUsuario"),
          ativo: "S",
          excluido: "N",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        setcodfuncionario(0);        

        setqtdeItensLanc(listaequipefuncionario.length + 1);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ExcluirCadItem() {
    api
      .delete("/v1/cadastro/equipefuncionario", {
        params: {
          codequipefuncionario,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        setqtdeItensLanc(listaequipefuncionario.length - 1);        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }  

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div>
          <div>
            <PopUp isOpen={isOpen} onClose={handleClose}>
              <h2>Verificação</h2>
              <p>Tem certeza que deseja excluir esse registro?</p>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleConfirma}
                  >
                    Sim
                  </button>
                  <button className="btn btn-danger" onClick={handleClose}>
                    Não
                  </button>
                </div>
              </div>
            </PopUp>

            <PopUp2 isOpen={isOpenFunc} onClose={handleCloseFunc}>
              <h2>Verificação</h2>
              <p>Tem certeza que deseja excluir esse Funcionário?</p>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleConfirmaFunc}
                  >
                    Sim
                  </button>
                  <button className="btn btn-danger" onClick={handleCloseFunc}>
                    Não
                  </button>
                </div>
              </div>
            </PopUp2>
          </div>

          <div>
            <PopUpMotivoExclusao isOpen={isOpenMotivoExclusao} onClose={handleCloseMotivoExclusao}>
              <h2>Antes de Excluir</h2>
              <p>Informe qual o motivo da exclusão?</p>

              <div className="col-sm-12">
                <label htmlFor="motivo" className="form-label">
                  Motivo
                </label>
                <input
                  type="text"
                  id="motivo"
                  className="form-control"
                  placeholder="Descreva aqui"
                  value={edtMotivo}
                  onChange={(e) => setEdtMotivo(e.target.value)}
                />
              </div>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleInformarMotivoExclusao}
                  >
                    Informar
                  </button>
                  <button className="btn btn-danger" onClick={handleCloseMotivoExclusao}>
                    Cancelar
                  </button>
                </div>
              </div>
            </PopUpMotivoExclusao>

            <PopUpMotivoExclusao2 isOpen={isOpenFuncMotivoExclusao} onClose={handleCloseMotivoExclusaoFunc}>
              <h2>Antes de Excluir</h2>
              <p>Informe qual o motivo da exclusão do funcionário?</p>

              <div className="col-sm-12">
                <label htmlFor="motivo" className="form-label">
                  Motivo
                </label>
                <input
                  type="text"
                  id="motivo"
                  className="form-control"
                  placeholder="Descreva aqui"
                  value={edtMotivo}
                  onChange={(e) => setEdtMotivo(e.target.value)}
                />
              </div>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleInformarMotivoExclusaoFunc}
                  >
                    Informar
                  </button>
                  <button className="btn btn-danger" onClick={handleCloseMotivoExclusaoFunc}>
                    Cancelar
                  </button>
                </div>
              </div>
            </PopUpMotivoExclusao2>
          </div>

          <Modal
            isOpen={showform}
            onRequestClose={closeModal}
            overlayClassName="modal-overlay"
            className="modal-content modal-xl"
          >
            <div className="container-fluid h-100">
              <div className="modal-header">
                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
              </div>              

              <div className="modal-body">
                <form>
                  <div className="row col-sm-12">
                    <div className="col-sm-9">
                      <label htmlFor="descricao" className="form-label">
                        Descrição
                      </label>
                      <input
                        type="text"
                        id="descricao"
                        className="form-control"
                        placeholder="Descrição"
                        value={edtdescricao}
                        onChange={(e) => setedtdescricao(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-8">
                      <label htmlFor="funcionario" className="form-label">
                        Funcionário
                      </label>
                      <select
                        id="funcionario"
                        className="form-select"
                        value={edtcodfuncionario}
                        onChange={(e) => setedtcodfuncionario(e.target.value)}
                      >
                        <option value="0">Escolha o funcionário</option>
                        {listafuncionario.map(function (funcionario) {
                          return (
                            <option
                              key={funcionario.codfuncionario}
                              value={funcionario.codfuncionario}
                            >
                              {funcionario.nome}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="col-sm-4">
                      <div>
                        <label htmlFor="ativo1" className="form-label">
                          Ativo
                        </label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="S"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "S"}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Sim
                          </label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="N"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "N"}
                          />
                          <label className="form-check-label">Não</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-5">
                      <label htmlFor="funcionario" className="form-label">
                        Funcionário da Equipe
                      </label>
                      <select
                        id="funcionario"
                        className="form-select"
                        value={codfuncionario}
                        onChange={(e) => setcodfuncionario(e.target.value)}
                      >
                        <option value="0">Escolha o funcionário</option>
                        {listafunc.map(function (func) {
                          return (
                            <option
                              key={func.codfuncionario}
                              value={func.codfuncionario}
                            >
                              {func.nome}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="col-sm-1 d-flex justify-content-center mt-2">
                      <button
                        type="button"
                        id="btnadd"
                        className="btn btn-success"
                        onClick={AddFuncionario}
                      >
                        Adicionar
                      </button>
                    </div>
                  </div>

                  <div className="row">
                    <div className="row col-sm-12">
                      <div className="row tabela">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th className="codigo">Código</th>
                              <th className="cnpj">Cód. Funcionário</th>
                              <th className="razao">Funcionário</th>
                              <th className="acao">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {listaequipefuncionario.map(function (item) {
                              return (
                                <tr key={item.codequipefuncionario}>
                                  <th>{item.codequipefuncionario}</th>
                                  <th>{item.codfuncionario}</th>
                                  <th>{item.nome}</th>
                                  <th>
                                    <div className="d-flex justify-content-center">
                                      <button
                                        type="button"
                                        id="btnexcluiritem"
                                        className="btn fa-solid fa-trash"
                                        onClick={() => handleOpenFunc(item)}
                                      ></button>
                                    </div>
                                  </th>
                                </tr>
                              );
                            })}
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colSpan={5}>
                                Quantidade de Registros:{" "}
                                {listaequipefuncionario.length}
                              </th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div className="modal-footer">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button className="btn btn-danger ms-4" onClick={closeModal}>
                    Cancelar
                  </button>
                  <button className="btn btn-success ms-4" onClick={Salvar}>
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>

        <div className="row">
          <h1 className="ms-4">Cadastro de Equipe</h1>
          <p className="ms-4">
            Rotina para cadastrar todas as equipes que vão para as rotas da
            empresa.
          </p>
          <hr />
        </div>

        <div className="row">
          <div className="col-10">
            <label className="d-block" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código, descrição ou funcionário"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => setabusca(e.target.value)}
            />
          </div>
          <div className="col-2 d-flex justify-content-center">
            <button
              className="btn btn-success btnnovo"
              onClick={() => openModalNovo()}
              disabled={!podeInserir("/cadastro/equipe")}
            >
              Novo
            </button>
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row tabela">
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="codigo">Código</th>
                <th className="razao">Descrição</th>
                <th className="fantasia">Funcionário</th>
                <th className="acao">Ações</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(function (item) {
                return (
                  <tr key={item.codequipe}>
                    <th>{item.codequipe}</th>
                    <th>{item.descricao}</th>
                    <th>{item.funcionario}</th>
                    <th>
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn fa-regular fa-pen-to-square"
                          onClick={() => openModalEditar(item)}
                          disabled={!podeEditar("/cadastro/equipe")}
                        ></button>
                        <button
                          className="btn fa-solid fa-trash"
                          onClick={() => handleOpen(item)}
                          disabled={!podeExcluir("/cadastro/equipe")}
                        ></button>
                      </div>
                    </th>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={5}>Quantidade de Registros: {lista.length}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
}

export default CadEquipe;
